import React, { Component } from 'react';
import { ToggleButtonGroup, ButtonToolbar, ToggleButton } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import '../../content/css/HighlightTexts.css';

const HIGHLIGHT_SECTIONS = { GUIDANCE: 0, EXAMPLES: 1, EXPLANATION: 2, APPROVAL: 3, NOTES: 4 };

export default class HighlightExportTextBox extends Component {
    constructor(props) {
        super(props);

        this.handleSectionToggle = this.handleSectionToggle.bind(this);
    }

    getMainContent() {
        if (this.props.highlight === null) return "";

        var max = this.props.highlightsCount;
        var highlight = this.props.highlight;
        var text = highlight.feedbackGuidance;
        //if (highlight.riskText) text += highlight.riskText;

        return text;
    }

    getExamplesContent() {
        if (this.props.highlight === null) return "";

        var highlight = this.props.highlight;
        return highlight.feedbackExamples;
    }

    getExplanationContent() {
        if (this.props.highlight === null) return "";

        var highlight = this.props.highlight;
        return highlight.feedbackExplanation;
    }

    getApprovalContent() {
        if (this.props.highlight === null) return "";

        var highlight = this.props.highlight;
        return highlight.feedbackApproval;
    }

    getNotesContent() {
        if (this.props.highlight === null) return "";

        var highlight = this.props.highlight;
        return highlight.notes;
    }

    getAdminContent() {
        if (this.props.highlight === null) return "";

        var highlight = this.props.highlight;
        var text = highlight.text;

        return text;
    }

    hasGuidance() {
        return this.props.highlight && this.props.visibleSections.includes(HIGHLIGHT_SECTIONS.GUIDANCE) && this.props.highlight.feedbackGuidance;
    }

    hasExamples() {
        return this.props.highlight && this.props.visibleSections.includes(HIGHLIGHT_SECTIONS.EXAMPLES) && this.props.highlight.feedbackExamples;
    }

    hasExplanation() {
        return this.props.highlight && this.props.visibleSections.includes(HIGHLIGHT_SECTIONS.EXPLANATION) && this.props.highlight.feedbackExplanation;
    }

    hasApproval() {
        return this.props.highlight && this.props.visibleSections.includes(HIGHLIGHT_SECTIONS.APPROVAL) && this.props.highlight.feedbackApproval;
    }

    hasNotes() {
        return this.props.highlight && this.props.visibleSections.includes(HIGHLIGHT_SECTIONS.NOTES) && this.props.highlight.notes != "";
    }

    handleSectionToggle(value) {
        this.props.onToggle(this.props.index, value);
    }

    render() {
        return (
            <div className="box">
                <div className="box-header">
                    <div className='marker' />
                    <span className="title"><strong>{this.props.highlight.categoryName}</strong></span>
                    <span className="position">{this.props.index + 1}/{this.props.highlightsCount}</span>
                </div>
                <div className="highlight-text"><span>{this.props.highlight.text}</span></div>
                <div>
                    {this.hasNotes() &&
                        <div className="section">
                            <div className="box-header">
                                <span className="title"><strong>Your notes</strong></span>
                            </div>
                            <ReactMarkdown classname="box-content" source={this.getNotesContent()} escapeHtml={false} />
                        </div>
                    }

                    {this.hasGuidance() &&
                        <div className="section">
                            <div className="box-header">
                                <span className="title"><strong>What to do</strong></span>
                            </div>
                            <ReactMarkdown classname="box-content" source={this.getMainContent()} escapeHtml={false} />
                        </div>
                    }

                    {this.hasExamples() &&
                        <div className="section">
                            <div className="box-header">
                                <span className="title"><strong>Example clause</strong></span>
                            </div>
                            <ReactMarkdown classname="box-content" source={this.getExamplesContent()} escapeHtml={false} />
                        </div>
                    }

                    {this.hasExplanation() &&
                        <div className="section">
                            <div className="box-header">
                                <span className="title"><strong>Background</strong></span>
                            </div>
                            <ReactMarkdown classname="box-content" source={this.getExplanationContent()} escapeHtml={false} />
                        </div>
                    }

                    {this.hasApproval() &&
                        <div className="section">
                            <div className="box-header">
                                <span className="title"><strong>Get approval</strong></span>
                            </div>
                            <ReactMarkdown classname="box-content" source={this.getApprovalContent()} escapeHtml={false} />
                        </div>
                    }

                    {this.props.isAdmin &&
                        <div className="section">
                            <div className="box-header">
                                <span className="title"><strong>Admin</strong></span>
                            </div>
                            <ReactMarkdown classname="box-content" source={this.getAdminContent()} escapeHtml={false} />
                        </div>
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Highlight/HighlightExportTextBox.js